export { getElevationQuestion, ParkElevationAnswer, LocationElevationAnswer } from './ElevationFaq';
